/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import _ from 'underscore';
import { DateInputRow } from '../../../../javascript/shared/components/form';

import { FormThemeContext } from './form_theme_context.js.jsx';
import { DateInputFloatingRow } from './date_input_floating_row.jsx';
import { RoomsReservationStatusBadge } from '../../admin/tabbed_event_form/components/rooms_reservation_status_badge.jsx';
import { getReservationStatusLabel } from '../../admin/tabbed_event_form/components/reservation_status_config.js';

export class InstanceListItem extends React.Component {
        static initClass() {
          this.contextType = FormThemeContext;

          this.defaultProps = {
            instances: null,
            hidden: false,
            timeZoneName: null,
            showReservationStatusColumn: false,
            readOnly: false
          };
        }

        constructor(props) {
          super(props);
          this._removeInstance = this._removeInstance.bind(this);
          this._editInstance = this._editInstance.bind(this);
this._saveInstance = this._saveInstance.bind(this);

          // HTML ID prefix to allow accessibility associations
          this.id_prefix = _.uniqueId('instance-item-');

          // Initial state
          this.state =
            {editing: false};
        }

        render() {
          const {start_date, start_time, end_time} = this.props.instance;

          const data = {
            // Short forms (for form data)
            start_date: (start_date != null ? start_date.toString('yyyy-MM-dd') : undefined),
            start_time: (start_time != null ? start_time.toString('HH:mm:00') : undefined),
            end_time:   (end_time != null ? end_time.toString('HH:mm:00') : undefined),

            // Long forms (for display)
            start_date_long: (start_date != null ? start_date.toString(Slzr.Formats.LongDate) : undefined),
            start_time_long: (start_time != null ? start_time.toString(Slzr.Formats.LongTime) : undefined),
            end_time_long:   (end_time != null ? end_time.toString(Slzr.Formats.LongTime) : undefined),

            // Objects (mainly for event callbacks, if needed)
            start_date_obj: start_date,
            start_time_obj: start_time,
            end_time_obj:   end_time
          };

          let date_string = data.start_date_long;
          const time_string = '';
          const serialized_value = [data.start_date, data.start_time, data.end_time].join(',');

          if (data.start_time) {
            date_string += ` ${  data.start_time_long}`;
            if (data.end_time) { date_string += (` to ${  data.end_time_long}`); }
            if (this.props.timeZoneName) { date_string += ` ${  this.props.timeZoneName}`; }
          }

          const { rooms_reservation: roomsReservation } = this.props.instance;

          const reservation_status_cell = this.props.showReservationStatusColumn && this.props.isRenderedInAdmin ?
            <span className="instance-reservation-status">
              {roomsReservation ?
                <RoomsReservationStatusBadge status={roomsReservation.status} />
              :
                null}
            </span>
          :
            null;

          const showEditControls = !this.props.readOnly;

          // Inner contents of the row, either the text or the edit state
          let row_contents = this.state.editing ?
            <div className="expanded" role="group" aria-labelledby={`${this.id_prefix  }-label`}>
              <span id={`${this.id_prefix  }-label`} className="instance_time">{date_string}</span>
              <div className="em-form_column-2">
                <DateInputFloatingRow label="Start Time" name="instance_start_time" type="time"
                                      timeError="Invalid start time"
                                      initialValue={start_time}
                                      ref="startTime"
                                      onEnterKey={this._saveInstance}/>
                <DateInputFloatingRow label="End Time" name="instance_end_time" type="time"
                                      timeError="Invalid end time"
                                      initialValue={end_time}
                                      ref="endTime"
                                      onEnterKey={this._saveInstance}/>
              </div>


              <div className="action_button inline_form_action_buttons">
                <a href="#" className="em-link" onClick={this._editInstance.bind(this, false)}>Cancel</a>
                <input type="submit" className="em-button em-primary" value="Update" onClick={this._saveInstance}/>
              </div>
            </div>
          :
            <p>
              <span id={`${this.id_prefix  }-label`} className="instance_time">{date_string}</span>
              {showEditControls &&
                <span className="deletex">
                    <a href="#"
                       onClick={this._editInstance.bind(this, true)}
                       title="Edit Time"
                       aria-describedby={`${this.id_prefix  }-label`}
                       className="edit_button">
                      <i className="fas fa-edit">
                        <span className="sr-only">Edit Time</span>
                      </i>
                    </a>
                    <a href="#"
                       onClick={this._removeInstance}
                       className="deletex_button"
                       title="Remove Instance"
                       aria-describedby={`${this.id_prefix  }-label`}>
                      <i className="fas fa-trash-alt">
                        <span className="sr-only">Remove Instance</span>
                      </i>
                    </a>
                </span>}
            </p>;

          if (this.props.isRenderedInAdmin) {
            // Inner contents of the row, either the text or the edit state
            row_contents = this.state.editing ?
              <h3 className="expanded" role="group" aria-labelledby={`${this.id_prefix  }-label`}>
                <span id={`${this.id_prefix  }-label`} className="instance_time">{date_string}</span>
                <DateInputRow label="Start Time" name="instance_start_time" type="time"
                              timeError="Invalid start time"
                              initialValue={start_time}
                              ref="startTime"
                              onEnterKey={this._saveInstance}
                              {...this.context.textInputRow} />
                <DateInputRow label="End Time" name="instance_end_time" type="time"
                              timeError="Invalid end time"
                              initialValue={end_time}
                              ref="endTime"
                              onEnterKey={this._saveInstance}
                              {...this.context.textInputRow} />

                <div className="action_button inline_form_action_buttons">
                  <a href="#" className="em-link" onClick={this._editInstance.bind(this, false)}>Cancel</a>
                  <input type="submit" className="btn btn-color" value="Update"
                         onClick={this._saveInstance}/>
                </div>
              </h3>
            :
              <h3 role="group" aria-labelledby={`${this.id_prefix  }-label`}>
                <span id={`${this.id_prefix  }-label`} className="instance_time">
                  {date_string}
                </span>
                {reservation_status_cell}
                {showEditControls &&
                  <span className="deletex">
                    <a href="#"
                       onClick={this._editInstance.bind(this, true)}
                       title="Edit Time"
                       aria-describedby={`${this.id_prefix  }-label`}
                       className="edit_button">
                      <i className="localist-icon-edit-small">
                        <span className="sr-only">Edit Time</span>
                      </i>
                    </a>
                    <a href="#"
                       onClick={this._removeInstance}
                       title="Remove Instance"
                       aria-describedby={`${this.id_prefix  }-label`}
                       className="deletex_button">
                      <i className="localist-icon-trash-small">
                        <span className="sr-only">Remove Instance</span>
                      </i>
                    </a>
                  </span>}
              </h3>;
          }

          const hidden_field = <input type="hidden" name="scheduled_date[]" value={serialized_value} />;

          // Result: div for the row, or only the input element if it's hidden
          if (this.props.hidden) {
            return hidden_field;
          }
            return <div className="item event_item" data-date={data.start_date} data-instance="true" role="group" aria-labelledby={`${this.id_prefix  }-label`}>
              {row_contents}
              {hidden_field}
            </div>;

        }

        _removeInstance(evt) {
          evt.preventDefault();

          if (this.props.instance.lock_reason === 'has_tickets') {
            alert('There are tickets confirmed for this event instance. Please assign all associated tickets to a new event instance before deleting.');
            return;
          }

          return this.props.eventInstances.removeAtIndex(this.props.index);
        }

        _editInstance(editing, evt) {
          this.setState({editing});
          return evt.preventDefault();
        }

        _saveInstance(evt) {
          const start_time = this.refs.startTime.state.currentValue;
          const end_time = this.refs.endTime.state.currentValue;

          // Call the handler with the updated data
          if (typeof this.props.onInstanceChanged === 'function') {
            this.props.onInstanceChanged({
            start_date: this.props.instance.start_date,
            start_time,
            end_time
          });
          }

          this.setState({editing: false});

          return evt.preventDefault();
        }
      }
InstanceListItem.initClass();
